<template>
<modal name="account-dialog"
  :adaptive="true"
  :scrollable="true"
  height="auto">
  <div class="v--modal-close-top">
    <el-button @click="closeDialog"
      icon="el-icon-close"
      type="text"></el-button>
  </div>
  <div class="setting">
    <div class="title">
      <h1>설정</h1>
    </div>
    <div v-if="$yagi.isYagiDaikon">🐐모드가 유효합니다.</div>
    <div class="user-avatar">
      <div class="image">
        <your-yagi :your-yagi-class="{}"
          :yagi-options="{dialogEnabled: true, rubyEnabled: false, messageEnabled: true}"></your-yagi>
      </div>
      <el-form :model="$yagi.profile"
        :rules="yagiRules"
        @submit.native.prevent
        ref="yagiForm">
        <div v-if="false">
          <el-form-item label="성명"
            prop="name">
            <el-input class="input-md"
              v-model="$yagi.profile.name"></el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="야기의색상변경"
            prop="color"
            class="yagi-color-select">
            <ul class="yagi-color-list">
              <li class="yagi-color-item"
                :style="{'background': color}"
                :key="index"
                :index="index"
                @click="$yagi.changeColor(color)"
                v-for="(color, index) in ['white', '#D7D7D7','#E0D0B6','#E3C9C2','#FFD0F6', '#ffffb7', '#b7ffb7', '#c1c1ff', '#1A5234', 'lightcyan', 'skyblue', 'plum', 'gold']">
              </li>
            </ul>
          </el-form-item>
        </div>
      </el-form>

    </div>
    <div v-if="!$deviceLib.isOnline">
        현재 오프라인입니다.
    </div>
    <div v-else-if="$firebase.isAuthenticated && false"
      class="is-authenticated">
      <div class="setting-item login-account">
        <h2>계정정보</h2>
        <div class="email"><span v-if="$firebase.user.displayName">{{ $firebase.user.displayName }} </span>[ {{ $firebase.user.email }} ] 으로 로그인중</div>
        <!-- <a @click="$firebase.signOut();$event.preventDefault()"
             href="#">ログアウトする</a> -->
        <div class="text-right">
          <el-button id="google-logout-account-dialog"
            @click="$firebase.signOut();$event.preventDefault()">로그아웃</el-button>
        </div>

      </div>

      <h2>백업(β판)</h2>
      <p>입력한 데이터를 서버에 저장하여 나중에 복원하거나 다른 기기로 데이터를 가져오기 할 수 있습니다.</p>
      <div class="text-right">
        <el-button type="success"
          @click="closeDialog();$router.push({name: 'backupIndex'});">백업화면으로</el-button>
      </div>
    </div>
    <div v-else-if="false"
      class="not-authenticated setting-item">
      <h2>로그인</h2>
      <p>로그인하면 입력한 내용을 서버에 백업하거나 자신의 주소로 이력서를 보내거나 편의점 인쇄 서비스를 이용하실 수 있습니다.</p>
      <login-forms />
    </div>
    <div v-if="false" class="setting-item data-clear">
      <h2>브라우저 자동저장</h2>
      <div>
        <el-switch v-model="$yagi.profile.autoSaveEnabled"
          active-text="ON"
          inactive-text="OFF"></el-switch>
      </div>
      <p>데이터를 자동적으로 브라우저내(IndexedDB, LocalStorage등)에 저장하여 이어작성하기가 가능 합니다. </p>
      <p>공용기기를 이용하시는 경우는 브라우저 데이터를 삭제 해주세요.</p>
    </div>
    <div v-if="false" class="setting-item">
      <h2>데이터・계정삭제</h2>
      <p>브라우저 내에 저장된 데이터나 서버 백업 데이터, 등록 계정 등을 삭제할 수 있습니다.</p>
      <div class="text-right">
        <el-button id="account-delete-account-dialog" type="success"
          @click="closeDialog();$router.push({name: 'accountDelete'});">데이터・계정삭제 화면으로 이동</el-button>
      </div>
    </div>
  </div>

  <div class="text-right">
    <el-button @click="closeDialog">닫기</el-button>
  </div>
</modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
import LoginForms from '@/components/LoginForms'
export default {
  components: {
    'login-forms': LoginForms
  },
  data: function () {
    return {
      yagiRules: {
        name: [
          {
            required: true,
            message: '이름을 입력',
            trigger: 'change'
          },
          {
            min: 1,
            max: 16,
            message: '16문자 이내로 입력',
            trigger: 'change'
          }]
      },
      clearLocalStorageConfirmVisible: false
    }
  },
  methods: {
    openDialog: function () {
      this.$modal.show('account-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    closeDialog: function () {
      this.$modal.hide('account-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('open-account-dialog', this.openDialog)
    this.$eventHub.$on('popstate', this.closeDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('open-account-dialog', this.openDialog)
    this.$eventHub.$off('popstate', this.closeDialog)
  }
}
</script>
